import React, { Component } from "react";
import Notification from "./../Notification";
import { Loader } from "semantic-ui-react";
import { connect } from "react-redux";
import "./index.css";

class NotificationsPanel extends Component {
  render() {
    const { notifications, isNotifcationsLoaded, closePopup } = this.props;
    return (
      <div className="notification-panel">
        <h5 className="-header">Notifications</h5>
        {!isNotifcationsLoaded ? (
          <div className="-no-notifications">
            <Loader size="small" active inline="centered" />
          </div>
        ) : notifications.length === 0 ? (
          <div className="-no-notifications">you don't have any notifications yet</div>
        ) : (
          notifications.map((notification, index) => (
            <Notification {...notification} key={index} closePopup={closePopup} />
          ))
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  notifications: state.notifications.data || [],
  shouldShowNotificationsCount: state.notifications.count > 0 && !state.notifications.isAllNotificationsSeen,
  count: state.notifications.count,
  isNotifcationsLoaded: state.notifications.isLoaded,
  lastSeenAt: state.notifications.lastSeenAt,
});

export default connect(mapStateToProps)(NotificationsPanel);



// WEBPACK FOOTER //
// ./src/components/Header/Components/NotificationsIndicator/componenets/NotifcationPanel/index.js